import React, { useEffect } from 'react'
import Pagination from '../nav/Pagination'
import Empty from '../feedback/Empty'
import moment from 'moment'
import utils from '../../utils'
import { FaCheck } from 'react-icons/fa'
import { FaX } from 'react-icons/fa6'

function StoresList(props) {
    const stores = props.stores

    useEffect(() => { }, [stores])
    return (
        <div className='p-3 bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark'>
            <div className='overflow-x-hidden'>
                <table className="table table-compact table-zebra w-full">
                    <thead>
                        <tr>
                            <th>Store</th>
                            <th className='hidden md:table-cell'>Is Verified</th>
                            <th>Products</th>
                            <th className='hidden md:table-cell'>Created</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stores?.results?.map((stores, idx) => (
                            <tr key={idx}>
                                <td className=''>
                                    <div className="flex gap-3 items-center">
                                        <div >
                                            <img src={stores?.logo} alt={stores?.name} className='h-16 rounded-lg w-16 hidden md:block' />
                                        </div>
                                        <div>
                                            <p className='font-bold'>
                                                {stores?.name}
                                            </p>
                                            <p className='text-gray-600'>
                                                {stores?.vendor?.full_name || '-'}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td className='hidden md:table-cell'>
                                    <div>
                                        {stores?.is_verified ? (
                                            <FaCheck />
                                        ) : (
                                            <FaX />
                                        )}
                                    </div>
                                </td>
                                <td className='font-bold'>
                                    {utils.toCommas(stores?.product_count || 0)}
                                </td>
                                <td className='hidden md:table-cell font-bold'>
                                    {moment(stores?.creation_time).format("MMM Do YYYY")}
                                </td>
                                <td>
                                    <button
                                        onClick={() => props.openModal(1, stores)}
                                        className='btn btn-sm btn-primary'>View</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {stores?.count < 1 ? (
                    <Empty objectName={"Stores"} />
                ) : null}
                {stores?.count ? (
                    <div className='mt-8 flex justify-center'>
                        <Pagination
                            count={stores?.count}
                            next={stores?.next}
                            previous={stores?.previous}
                            changePageParam={props.changePageParam}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default StoresList